import { Grid } from '@hiiretail/react-foundation-ui';
import { ItemSearchReturnResponse, useLazyGetItemsQuery } from 'app/services/itemsSearchService';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { ItemsSearchAutocomplete } from './components/ItemsSearchAutocomplete';

const QUERY_MIN_LENGTH = 3;
const QUERY_DEBOUNCE_DEALY_MS = 500;

export const ItemSearch = () => {
  const [query, setQuery] = useState<string>('');
  const trimmedQuery = query.trim();
  const [debouncedQuery] = useDebounce(trimmedQuery, QUERY_DEBOUNCE_DEALY_MS);
  const shouldSearch = debouncedQuery?.length >= QUERY_MIN_LENGTH;

  const [execute, { data, isFetching: loading }] = useLazyGetItemsQuery();

  const handleClearInput = () => setQuery('');

  const search = useCallback(() => {
    if (shouldSearch) {
      execute({ search: debouncedQuery });
    }
  }, [debouncedQuery, execute, shouldSearch]);

  const handleChangeInput = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => setQuery(event.target.value),
    [],
  );

  useEffect(() => {
    search();
  }, [search]);

  return (
    <Grid item xs={12} sm={5}>
      <ItemsSearchAutocomplete
        value={query}
        onChangeText={handleChangeInput}
        onClear={handleClearInput}
        onSearch={search}
        items={data as ItemSearchReturnResponse[]}
        loading={loading}
        openSuggestions={shouldSearch}
      />
    </Grid>
  );
};
